import { ConjunctionMode } from "@redotech/redo-customer-segments-common/segments/segment-types";
import {
  RedoBadge,
  RedoBadgeProps,
} from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import * as segmentBuilderCss from "./segment-builder.module.css";

export const ConditionConnector = memo(function ConditionConnector({
  conjunction,
}: {
  conjunction: ConjunctionMode;
}) {
  return (
    <Flex
      align="center"
      className={segmentBuilderCss.connectorContainer}
      dir="column"
      gap="none"
    >
      <span className={segmentBuilderCss.connectorLine} />
      <RedoBadge {...conjunctionModeToBadgeProps[conjunction]} size="sm" />
      <span className={segmentBuilderCss.connectorLine} />
    </Flex>
  );
});

const conjunctionModeToBadgeProps: Record<ConjunctionMode, RedoBadgeProps> = {
  [ConjunctionMode.AND]: { color: "indigo", text: "And" },
  [ConjunctionMode.OR]: { color: "orange", text: "Or" },
};
